<div class="not-found">
  <mat-card appearance="outlined" class="not-found__content">
    <mat-card-header>
      <mat-card-title>{{ 'Hier ist etwas schiefgelaufen.' | translate }}</mat-card-title>
      <mat-card-subtitle>{{
        'Diese Seite existiert leider nicht. Wenn Sie den Fehler melden möchten oder Hilfe benötigen, wenden Sie
        sich bitte an info@phaenonet.ch.' | translate
      }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions class="center-actions">
      <button class="not-found__button" mat-flat-button color="primary" routerLink="/map">
        {{ 'zurück zur Karte' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
